export function getImgPath(path){
    return process.env.VUE_APP_IMAGE_URL+path;
    //return localStorage.getItem('server')+'/storage/'+path;
}

export const statusOptions = [
    {label: 'Active', value: 1},
    {label: 'Inactive', value: 0},
    {label: 'All', value: -1}
];